module.exports = __webpack_public_path__ + "img/600.89d15a10.svg";